/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { verificationRequest } from '../fn/organizations/verification-request';
import { VerificationRequest$Params } from '../fn/organizations/verification-request';
import { VerificationRequestResponse } from '../models/verification-request-response';

@Injectable({ providedIn: 'root' })
export class OrganizationsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `verificationRequest()` */
  static readonly VerificationRequestPath = '/api/v1/verification-request';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verificationRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verificationRequest$Response(params: VerificationRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<VerificationRequestResponse>> {
    return verificationRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verificationRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verificationRequest(params: VerificationRequest$Params, context?: HttpContext): Observable<VerificationRequestResponse> {
    return this.verificationRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<VerificationRequestResponse>): VerificationRequestResponse => r.body)
    );
  }

}
